import { useState } from "react";
import { Login } from "@/pages/CrmEntry";
import { getStaffInfo, clearStaffSession } from "@/lib/api";
import DispatchPortal from "@/pages/portals/DispatchPortal";

export default function DispatchEntry() {
  const [info, setInfo] = useState(getStaffInfo());
  if (info && (info.role === "manager" || info.role === "dispatcher")) {
    return <DispatchPortal info={info} onLogout={() => { clearStaffSession(); setInfo(null); }} />;
  }
  return <Login expectedRole="dispatch" onAuthed={setInfo} />;
}
